import { Box, Flex } from '@chakra-ui/react';
import { DropdownItem } from '@mesh.ai/rabbit';

import { Check } from 'assets/assetsV1/iconComponents';

import { Divider } from 'uiToolkitV1/Divider';
import { TextLabel } from 'uiToolkitV1/Typography';

import { CascadingApplyOption, CASCADING_OPTIONS } from './shared/cascadingOptions';

interface CascadingOptionsMenuProps {
  selectedOption: CascadingApplyOption;
  onOptionChange: (option: CascadingApplyOption) => void;
}

export const CascadingOptionsMenu = ({ selectedOption, onOptionChange }: CascadingOptionsMenuProps) => (
  <Box width="100%">
    <Box px="12px" py="8px">
      <TextLabel bold color="text.g2" textTransform="uppercase">
        Applies to
      </TextLabel>
      <Divider borderColor="#E7E7E7" marginTop="8px" marginBottom="4px" width="100%" mx="auto" />
      {CASCADING_OPTIONS.map((option) => (
        <DropdownItem key={option.value} onClick={() => onOptionChange(option.value)}>
          <Flex alignItems="center" justifyContent="space-between" width="100%">
            {option.label}
            {selectedOption === option.value && <Check />}
          </Flex>
        </DropdownItem>
      ))}
    </Box>
  </Box>
);
